import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box, Body } from '@hover/blueprint';
import { primary600, primary700 } from '@hover/tokens-color';
import styled from '@emotion/styled';
import { Control, FieldValues, UseFormSetValue } from 'react-hook-form';
import {
  IJobDemographicQuestions,
  IJobDemographicQuestion,
  IJobDemographicAnswerOption,
} from '../../../interfaces/IJobDemographicQuestion';
import DemographicQuestion from './DemographicQuestion';

const StyledDescriptionContainer = styled.div`
  p {
    margin-bottom: 2rem;
  }

  p:first-child {
    margin-bottom: 1.5rem;
  }

  p:last-child {
    color: ${primary600};

    &:hover {
      color: ${primary700};
    }

    font-weight: 600;
  }
`;

interface Props {
  demographicQuestions: IJobDemographicQuestions;
  control: Control;
  setValue: UseFormSetValue<FieldValues>;
}

const DemographicQuestions: React.FC<Props> = ({
  demographicQuestions,
  control,
  setValue,
}) => {
  const { header, description, questions } = demographicQuestions;

  return (
    <Box flexDir="column" mt="56px">
      <Body isBold mb={200}>
        {header}
      </Body>
      <StyledDescriptionContainer>
        {ReactHtmlParser(description)}
      </StyledDescriptionContainer>
      {questions.map((question: IJobDemographicQuestion) => {
        const { answer_options: answerOptions } = question;
        const normalizedOptions = answerOptions.map(
          (option: IJobDemographicAnswerOption) => ({
            value: option.label,
            key: option.id,
          }),
        );
        return (
          <DemographicQuestion
            control={control}
            demographicQuestion={question}
            dropdownList={normalizedOptions}
            setValue={setValue}
          />
        );
      })}
    </Box>
  );
};

export default DemographicQuestions;
